/**
 * v1.14.70.0 — AI Site Doctor Error Boundary (FASE 7A).
 * Wrappa top-level di App.js. Cattura errori React, riporta, mostra UI fallback.
 */
import React from "react";
import { reportError } from "../services/aiSiteDoctorClient";

export default class AISiteDoctorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error?.message || "Unknown error" };
  }

  componentDidCatch(error, info) {
    try {
      reportError({
        source: "frontend",
        severity: "critical",
        error_message: error?.message || "React boundary caught error",
        stack_trace: (error?.stack || "").slice(0, 2000)
                       + "\n---componentStack---\n"
                       + (info?.componentStack || "").slice(0, 1500),
        component_name: "AISiteDoctorBoundary",
        page_url: window.location.pathname,
      });
    } catch (_) { /* never throw inside catch */ }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="ai-site-doctor-fallback"
              style={{
                minHeight: "100vh", background: "#FCFCFA",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontFamily: "system-ui, -apple-system, sans-serif",
                padding: "24px",
              }}>
          <div style={{
            maxWidth: 480, padding: 32, background: "white",
            border: "1px solid #E5E2DB", borderRadius: 16,
            textAlign: "center",
          }}>
            <div style={{
              width: 56, height: 56, margin: "0 auto 16px",
              background: "#FEF3C7", borderRadius: "50%",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 28,
            }}>!</div>
            <h2 style={{ color: "#0F1F14", marginBottom: 8 }}>
              Si è verificato un problema tecnico
            </h2>
            <p style={{ color: "#4A5E51", marginBottom: 20, lineHeight: 1.5 }}>
              I tuoi dati sono stati salvati e stiamo verificando il problema.
              Puoi ricaricare la pagina per continuare.
            </p>
            <button onClick={this.handleReload}
                     data-testid="ai-site-doctor-reload-btn"
                     style={{
                       padding: "10px 20px", background: "#163321",
                       color: "white", border: "none", borderRadius: 999,
                       cursor: "pointer", fontSize: 14, fontWeight: 500,
                     }}>
              Ricarica pagina
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
